import React from 'react';
import { Icons } from '@ohif/ui-next';

interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  illustrationType?: 'empty-box' | 'no-data';
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  illustrationType = 'empty-box',
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '17px',
        padding: '48px 24px',
        minHeight: 'calc(100vh - 56px)',
      }}
    >
      {/* Content Container - matches Figma width of 323px */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '17px',
          width: '323px',
        }}
      >
        {/* Empty Box Illustration */}
        <div
          style={{
            width: '218px',
            height: '218px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icons.EmptyBox />
        </div>

        {/* Title */}
        <p
          style={{
            fontSize: 'var(--font-size-md)',
            fontWeight: 'var(--font-weight-medium)',
            color: 'var(--text-secondary)',
            textAlign: 'center',
            margin: 0,
            lineHeight: '24px',
          }}
        >
          {title}
        </p>

        {/* Description */}
        {description && (
          <p
            style={{
              fontSize: 'var(--font-size-sm)',
              fontWeight: 'var(--font-weight-normal)',
              color: 'var(--text-muted)',
              textAlign: 'center',
              margin: 0,
              maxWidth: '400px',
            }}
          >
            {description}
          </p>
        )}

        {/* Action Button - full width of container (323px) */}
        {actionLabel && onAction && (
          <button
            onClick={onAction}
            className="btn btn-primary"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '0 12px',
              height: '36px',
              borderRadius: '4px',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3.33337V12.6667M3.33334 8H12.6667"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span style={{ fontSize: '14px', fontWeight: 500 }}>{actionLabel}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
